export default __webpack_public_path__ + "static/media/logo_mesa_servicio.1d8daf79.png";